import { createContext } from "react";
import { LayoutType } from "../../config/global";

const LayoutContext = createContext({
    layout: LayoutType.horizontal,
    changeLayout: (layout: LayoutType) => {}
})

export default LayoutContext